import { TableIcons, TBaseProps } from '@sim-admin-frontends/ui-shared';
import { FC } from 'react';
import { App } from '@sim-admin-frontends/data-access';

import { useGeneratePaymentActions } from '../../../hooks/actionButtons/useGeneratePaymentActions';

interface PaymentsTableMenuProps extends TBaseProps {
  id: string;
  app?: App;
}

const PaymentsTableMenu: FC<PaymentsTableMenuProps> = ({ testId, id, app }) => {
  const { listActions: items } = useGeneratePaymentActions({ id, app });
  return <TableIcons items={items} testId={testId} />;
};

export default PaymentsTableMenu;
